export default "__VITE_PUBLIC_ASSET__1b781dfe__"